import React, { Component, Fragment } from "react";
import {
  AppBar,
  Button,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { LOGO_VERIFY } from "./../../config/config";
import { verfiyDomain } from "../../config/api_calls";
import HelperClass from "./../../config/helperClass";
import { tableLoader } from "../ContentLoaders/table_loader";
import Skeleton from "@material-ui/lab/Skeleton";
const auth = new HelperClass();
export class DomainConnect extends Component {
  continue = () => {
    //e.preventDefault();
    this.props.nextStep();
  };
  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  submitForms = (e) => {
    e.preventDefault();
    this.setState({
      tableLoader: true,
      disabled: true,
    });
    this.props.VerifyConnection();
    setTimeout(() => {
      this.setState({
        tableLoader: false,
        disabled: false,
      });
      this.continue();
    }, 5000);
  };

  constructor() {
    super();
    this.state = {
      disabled: false,
      errorMessage: "",
      tableLoader: false,
      dnsList: [],
    };
  }

  modalHideIns = () => {
    window.$("#instructionsModal").modal("hide");
  };

  render() {
    //const { VerifyConnection } = this.props;
    const {
      values: { domain_title, domain_name, dnsList, a_ip },
    } = this.props;

    return (
      <>
        <div className="col-lg-12">
          <div className="nk-block">
            <div className="card card-bordered card-stretch">
              <div className="card-inner-group" style={{ padding: "40px" }}>
                {this.state.errorMessage !== "" ? (
                  <div
                    className="example-alert"
                    style={{ marginBottom: "15px" }}
                  >
                    <div className="alert alert-pro alert-danger">
                      <div className="alert-text">
                        <h4>Error</h4>
                        <p>{this.state.errorMessage}</p>
                      </div>
                    </div>
                  </div>
                ) : null}
                <h6>Domain</h6>

                {/* Editable on every step: changes go straight to the wizard
                    parent's state, and a changed domain name clears any DNS
                    result so it must be verified again. */}
                <div className="form-group">
                  <TextField
                    required
                    id="domain_title"
                    name="domain_title"
                    type="text"
                    label="Domain Title"
                    defaultValue={domain_title}
                    inputProps={{ maxLength: 100 }}
                    onChange={this.props.handleChange("domain_title")}
                    helperText="Enter the domain title. e.g ABC Company"
                    variant="outlined"
                    fullWidth
                    disabled={this.state.disabled}
                  />
                </div>
                <div className="form-group">
                  <TextField
                    required
                    id="domain_name"
                    name="domain_name"
                    type="text"
                    label="Domain"
                    defaultValue={domain_name}
                    inputProps={{ maxLength: 100 }}
                    onChange={this.props.handleChange("domain_name")}
                    helperText="Enter the domain you want to connect. e.g. example.com (without http:// or https://). Changing it requires verifying the connection again."
                    variant="outlined"
                    fullWidth
                    disabled={this.state.disabled}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="nk-block">
            <div className="card card-bordered card-stretch">
              <div className="card-inner-group" style={{ padding: "40px" }}>
                <h6>Connect your domain</h6>
                {this.state.tableLoader === true ? (
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <p>Verifying Connection</p>
                    <img
                      src={LOGO_VERIFY}
                      alt="logo"
                      style={{ height: "200px" }}
                    />
                  </div>
                ) : (
                  <p>
                    To connect your domain, sign in to your domain provider and update your DNS settings.
                    Select <strong>View Instructions</strong> for step-by-step guidance.
                    <br />
                    <br />
                    <button
                      className="btn btn-success"
                      data-toggle="modal"
                      data-target="#instructionsModal"
                    >
                      View Instructions
                    </button>
                    <br />
                    <br />
                    <span>
                      After saving your changes, select Verify Connection to confirm your domain is configured correctly.
                    </span>
                  </p>
                )}

                <hr />
                <div className="form-group text-right">
                  <button
                    className="btn btn-lg btn-default  btn-outline-dark"
                    disabled={this.state.disabled}
                    onClick={this.back}
                    style={{ marginRight: "10px" }}
                  >
                    Back
                  </button>

                  {this.state.tableLoader === true ? (
                    <button
                      className="btn btn-lg btn-primary"
                      style={{ marginRight: "15px" }}
                      disabled
                    >
                      <em className="icon ni ni-swap"></em> Verifying Connection
                      <div
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </button>
                  ) : (
                    <button
                      className="btn btn-lg btn-primary"
                      disabled={this.state.disabled}
                      onClick={this.submitForms}
                    >
                      Verify Connection
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" tabIndex="-1" id="instructionsModal">
          <div className="modal-dialog  modal-lg" role="document">
            <div className="modal-content">
              <a
                style={{ cursor: "pointer" }}
                className="close"
                onClick={() => {
                  this.modalHideIns();
                }}
              >
                <em className="icon ni ni-cross"></em>
              </a>
              <div className="modal-body modal-body-lg">
                <div className="nk-modal">
                  <h4 className="nk-modal-title">
                    Connect an existing domain
                  </h4>
                  <div className="nk-modal-text">
                    <p>
                      If your domain is registered with another provider, update
                      its DNS settings as follows:
                    </p>
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item">
                        <strong>A record:</strong> Point your primary domain to{" "}
                        <strong>{process.env.REACT_APP_AGENT_PORTAL_DNS}</strong>
                        .
                      </li>
                    </ul>
                    <div className="callout callout-default">
                      <strong>Important:</strong> Your primary domain should
                      have only one A record. If another A record already exists
                      for the same hostname (for example, <code>@</code>),
                      replace it with{" "}
                      <code>{process.env.REACT_APP_AGENT_PORTAL_DNS}</code>.
                    </div>
                    <h5 className="mt-3">Before you begin</h5>
                    <p>
                      Changing your DNS settings may affect services that use
                      your domain, such as your website or email, depending on
                      how your DNS is currently configured.
                    </p>
                    <p>
                      If you're unsure, contact your domain provider before
                      making changes.
                    </p>
                    <p>
                      Some providers (such as GoDaddy, Hover, Google Domains, or
                      IONOS) have different interfaces, but the required DNS
                      changes are the same.
                    </p>
                  </div>
                  <div className="nk-modal-action">{"  "}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default DomainConnect;
